import React from 'react';
import AppRoutes from './Router'; // Import the AppRoutes component
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from "@vercel/analytics/react"

const App = () => {
  return (
    <div>
      <ToastContainer position="bottom-right" />
      <AppRoutes />
      <SpeedInsights />
      <Analytics />
    </div>
  );
};

export default App;
